"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useRecommendationCosts = require("../../../../hooks/recommendation/useRecommendationCosts");
var _services = require("../../../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Prices = function Prices() {
  var breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  var _useRecommendationCos = (0, _useRecommendationCosts.useRecommendationCosts)(),
    handsetTermCost = _useRecommendationCos.handsetTermCost,
    handsetUpfrontCost = _useRecommendationCos.handsetUpfrontCost;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 3,
      md: 3
    },
    spacing: 3,
    justify: breakpoints.sm && 'center'
  }, handsetUpfrontCost > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 1,
      md: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    justify: breakpoints.sm && 'center'
  }, _services.locale.localeString('Recommendation.StickyFooterUpfront')), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    weight: 3,
    justify: breakpoints.sm && 'center',
    text: _services.locale.formatPrice(handsetUpfrontCost)
  }))), handsetTermCost > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 1,
      md: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    justify: breakpoints.sm && 'center'
  }, _services.locale.localeString('Recommendation.StickyFooterMonthly')), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    weight: 3,
    justify: breakpoints.sm && 'center',
    text: _services.locale.formatPrice(handsetTermCost)
  }))));
};
var _default = Prices;
exports.default = _default;